export enum PaymentTypeEnum {
  'Okänd' = 0,
  'Faktura via brev' = 1,
  'Faktura via epost' = 2,
  'Kort' = 4,
  'Kort/Direktbetalning' = 8,
  'Swish' = 16,
}
